import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Popup, ScrollView } from "devextreme-react";
import { TextArea } from "devextreme-react/text-area";
import { Button } from "devextreme-react/button";
import { LoadPanel } from "devextreme-react/load-panel";
import axios from "axios";

function ProductionStatusPopup(props) {
    const { showPopup = {}, setShowPopup, oidc } = props;
    const visible = showPopup.visible === true;
    const headerRowId = showPopup.headerRowId;

    const [statusText, setStatusText] = useState("");
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!visible || !headerRowId) {
            setStatusText("");
            setError(null);
            return;
        }
        let cancelled = false;
        props.setLoadPanelVisible(true);
        setError(null);
        const baseUrl = window._env_?.REACT_APP_APIS || "";
        const token = oidc?.user?.access_token;
        axios
            .get(`${baseUrl}/om/SalesOrderHeaderOperations/GetProductionDescriptiveStatus`, {
                params: { headerRowId },
                headers: token ? { Authorization: `Bearer ${token}` } : {},
            })
            .then((res) => {
                if (!cancelled) {
                    setStatusText(typeof res.data === "string" ? res.data : String(res.data ?? ""));
                }
            })
            .catch((err) => {
                if (!cancelled) {
                    setError(err.response?.data ?? err.message ?? "Failed to load production status.");
                    setStatusText("");
                }
            }).finally(() => {
                props.setLoadPanelVisible(false);
            });
        return () => { cancelled = true; };
    }, [visible, headerRowId, oidc?.user?.access_token]);

    const handleHiding = () => {
        setShowPopup((prev) => ({ ...prev, visible: false }));
        setStatusText("");
        setError(null);
    };

    const handlePrint = () => {
        const printWindow = window.open("", "_blank");
        if (!printWindow) return;
        const title = showPopup.title ?? "Production Status";
        const content = statusText || " ";
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>${title}</title>
                <style>
                    body { font-family: sans-serif; padding: 16px; white-space: pre-wrap; }
                    h2 { margin: 0 0 12px 0; font-size: 1.1em; }
                </style>
            </head>
            <body>
                <h2>${title}</h2>
                <div>${content.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br/>")}</div>
            </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 250);
    };

    return (
        <>
            {visible ? (
                <Popup
                    visible={true}
                    onHiding={handleHiding}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    title={showPopup.title ?? "Production Status"}
                    container="#root"
                    width="40vw"
                    height="40vh"
                >
                    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                        {error && <div className="p-2 text-danger">{error}</div>}
                        <TextArea
                            value={statusText}
                            labelMode='static'
                            stylingMode='outlined'
                            readOnly={true}
                            height="100%"
                            width="100%"
                            minHeight="200px"
                        />
                        <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 12, paddingTop: 12, borderTop: "1px solid #ddd" }}>
                            <Button text="Ok" type="default" onClick={handleHiding} />
                            <Button text="Print" icon="print" type="default" onClick={handlePrint} />
                        </div>
                    </div>
                </Popup>
            ) : null}
        </>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(ProductionStatusPopup);
